import { uniqBy } from "lodash-es";
import { IComData, ISoftData, ISoftTab } from "@/common/interface";
import { OpenType } from "@q/softCore";

export const replaceComdataToPage = (
  showIds: string[],
  comData: IComData,
  data: ISoftData[],
) => {
  try {
    const { adspaces } = comData;
    if (Array.isArray(showIds) && showIds.length) {
      showIds.forEach((showid, index) => {
        if (adspaces[showid]) {
          // 替换 +1
          const { dj_softwareId, img, title, dj_softwareName, clktk, imptk } =
            adspaces[showid].ads[0];
          data[index] = {
            ...data[index],
            soft_id: dj_softwareId,
            url: img,
            name: dj_softwareName, // 待定
            category: "2",
            open_type: OpenType.download,
            open_first: "0",
            desc: title,
            clktk,
            imptk,
            isCom: true,
          };
        }
      });
    }
    return data;
  } catch (e) {
    return data;
  }
};

export const replaceComdataToTab = (
  showIds: string[],
  comData: IComData,
  data: ISoftTab[],
  tabTitle: string,
) => {
  try {
    const { adspaces } = comData;
    if (Array.isArray(showIds) && showIds.length) {
      showIds.forEach((showid, index) => {
        if (adspaces[showid]) {
          // 替换 +1
          const { dj_softwareId, img, title, dj_softwareName, clktk, imptk } =
            adspaces[showid].ads[0];

          const tabIndex = data.findIndex((soft_tabs: any) => {
            return soft_tabs.title == tabTitle;
          });
          data[tabIndex].data[index] = {
            soft_id: dj_softwareId,
            url: img,
            name: dj_softwareName, // 待定
            category: "2",
            open_type: OpenType.download,
            open_first: "0",
            desc: title,
            clktk,
            imptk,
          };
        }
      });
    }
    return data;
  } catch (e) {
    return data;
  }
};

// const bannerMap = {
//   soft_id: "dj_softwareId",
//   name: "dj_softwareName",
//   slider_pic_href: "img"
// }

const bannerMap = {
  dj_softwareId: "soft_id",
  dj_softwareName: "name",
  img: "url",
  clktk: "clktk",
  imptk: "imptk",
};

export const pmpBannerMap = {
  dj_softwareId: "soft_id",
  dj_softwareName: "name",
  img: "slider_pic_href",
  clktk: "clktk",
  imptk: "imptk",
  desc: "pic_desc",
};

export const pmpScheduleMap = {
  dj_softwareId: "soft_id",
  dj_softwareName: "name",
  img: "pic_url",
  title: "calander_desc",
  desc: "calendar_title",
  clktk: "clktk",
  imptk: "imptk",
};

export const pmpNetWorkMap = {
  dj_softwareId: "soft_id",
  dj_softwareName: "name",
  img: "choice_pic_href_max",
  clktk: "clktk",
  imptk: "imptk",
};

export const pmpAdMap = {
  dj_softwareId: "soft_id",
  dj_softwareName: "name",
  img: "openScreenAd_pic_href",
  clktk: "clktk",
  imptk: "imptk",
};

export const pmpindexAdMap = {
  dj_softwareId: "soft_id",
  dj_softwareName: "name",
  img: "url",
  clktk: "clktk",
  imptk: "imptk",
  instsoftid: "instsoftid",
};

export const pmpRankMap = {
  dj_softwareId: "soft_id",
  dj_softwareName: "soft_name",
  img: "logo",
  clktk: "clktk",
  imptk: "imptk",
};

interface MapT {
  [key: string]: string;
}

const mapValue = (transMap: MapT, pmpData: any, originData: any = {}) => {
  for (const [key, value] of Object.entries(transMap)) {
    originData[value] = pmpData[key];
  }
  return originData;
};

export const replaceComdataToGamepage = (
  showIds: string[],
  comData: IComData,
  data: ISoftData[],
  area: MapT,
) => {
  try {
    const { adspaces } = comData;
    if (Array.isArray(showIds) && showIds.length) {
      showIds.forEach((showid, index) => {
        if (adspaces[showid]) {
          // 替换 +1
          // const { dj_softwareId, img, title, dj_softwareName } = adspaces[showid].ads[0];
          const transData = mapValue(
            area,
            adspaces[showid].ads[0],
            data[index],
          );
          data[index] = {
            ...data[index],
            ...transData,
            category: "2",
            open_type: "5",
            open_first: "0",
            isCom: true,
          };
          // data[index][pmpBannerMap.dj_softwareId] = adspaces[showid].ads[0][]
        }
      });
    }
    return data;
  } catch (e) {
    return data;
  }
};

// 商业化埋点
export const comMonitor = (url: string) => {
  const image = new Image();
  image.src = url;
};

// url模板宏替换
export const replaceUrlTemplate = (
  url: string,
  event: React.MouseEvent,
  st: number,
  et: number,
): string => {
  const target = event.currentTarget as HTMLElement;
  const currentTargetRect = event.currentTarget.getBoundingClientRect();
  let left = currentTargetRect.left;
  let top = currentTargetRect.top;
  const pageX = event.pageX || Number(window.localStorage.getItem("pageX"));
  const pageY = event.pageY || Number(window.localStorage.getItem("pageY"));
  const position = window.localStorage.getItem("position") || "";
  if (position === "mainbanner") {
    left = 284;
    top = 10;
  }
  const event_offsetX = Math.floor(pageX - left);
  const event_offsetY = Math.floor(pageY - top - window.scrollY);

  return url
    .replaceAll("__OFFSET_X__", `${event_offsetX <= 0 ? 0 : event_offsetX}`)
    .replaceAll("__OFFSET_Y__", `${event_offsetY <= 0 ? 0 : event_offsetY}`)
    .replaceAll("__EVENT_TIME_START__", `${st}`)
    .replaceAll("__EVENT_TIME_END__", `${et}`)
    .replaceAll("__ADSPACE_W__", `${target.clientWidth}`)
    .replaceAll("__ADSPACE_H__", `${target.clientHeight}`);
};

interface IDownloadProgress {
  isClick: boolean;
  position: string;
}
// localstorge打标
export const setDownLoadStore = (key: string, value: IDownloadProgress) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getDownLoadStore = (key: string) => {
  let result;
  try {
    result = JSON.parse(localStorage.getItem(key) || "{}");
  } catch (e) {
    result = {};
  }
  return result;
};

export const removeDownLoadStore = (key: string) => {
  localStorage.removeItem(key);
};

export const randomMath = (max: number, min: number): number => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const sortDataTop = (data: any) => {
  try {
    data.forEach((item: any) => {
      const index = item.calendar_title.indexOf("日");
      const sliceCalendar = item.calendar_title.substring(0, index + 1);
      item.sliceCalendar = new Date(
        `${new Date().getFullYear}/${sliceCalendar
          .replace("月", "/")
          .replace("日", "")}`,
      );
    });
    return data.sort((a: any, b: any) => {
      if (b.sliceCalendar.getTime() == a.sliceCalendar.getTime()) {
        if (a.clktk && !b.clktk) {
          return -1;
        } else if (!a.clktk && b.clktk) {
          return 1;
        } else {
          return 0;
        }
      }
      return b.sliceCalendar.getTime() - a.sliceCalendar.getTime();
    });
  } catch (e) {
    console.log(e);
    return data;
  }
};

// bannner逻辑特殊
export const sortRandomBanner = (
  banners: ISoftData[],
  pmdData: IComData,
  ids: string[],
) => {
  try {
    const { adspaces } = pmdData;
    const comBanners: any[] = [];
    ids.forEach((showid, index) => {
      if (adspaces[showid]) {
        // 替换 +1
        // const { dj_softwareId, img, title, dj_softwareName } = adspaces[showid].ads[0];
        // debugger
        const transData = mapValue(bannerMap, adspaces[showid].ads[0]);
        comBanners.push({
          ...transData,
          category: "2",
          open_type: "5",
          open_first: "0",
          isCom: true,
        });
        // data[index][pmpBannerMap.dj_softwareId] = adspaces[showid].ads[0][]
      }
    });
    comBanners.sort(() => {
      return Math.random() - 0.5;
    });

    // banners.sort(() => {
    //   return Math.random() - 0.5;
    // });

    banners.forEach((item, index) => {
      if (item.category == "2") {
        banners.splice(index, 1);
        banners.unshift(item);
      }
    });

    const newBanners = [...comBanners, ...banners];
    let uniqBanners = uniqBy(newBanners, "soft_id");
    uniqBanners =
      uniqBanners.length && uniqBanners.length >= 8
        ? uniqBanners.slice(0, 8)
        : uniqBanners;
    return uniqBanners;
  } catch (e) {
    return banners;
  }
};
